<template>
  <div class="report-page">
    <div class="report-container">
      <div class="top-meta">{{ formatDateTime(new Date()) }}</div>
      <div class="title-wrap">
        <h1 class="title">{{ adminText('organizationAll.izvje_e_po_priredbama_10b86df3', 'Izvješće po priredbama') }}</h1>
        <div v-if="from && to" class="period">{{ from }} - {{ to }}</div>
      </div>
      <div class="org-info">
        <div v-if="organization">
          {{ organization.publicName }}{{ adminText('organizationAll.oib_1ed06465', ', OIB:') }} {{ organization.OIB }}, {{ organization.address }},
          {{ organization.city }}
        </div>
        <div>
          <span v-if="salePointsList.length">{{ adminText('organizationAll.prodajna_mjesta_19103895', 'Prodajna mjesta:') }} </span>
          <span v-if="salePointsList.length" class="bold">{{ salePointsList.join(', ') }}</span>
        </div>
        <div v-if="filterLabels && filterLabels.length">
          <div>{{ adminText('organizationAll.filteri_10ae0e96', 'Filteri:') }}</div>
          <ul class="filters">
            <li v-for="filter in filterLabels" :key="filter.label">
              {{ filter.label }}: <span class="bold">{{ filter.value }}</span>
            </li>
          </ul>
        </div>
      </div>

      <h2 class="h-section">{{ adminText('organizationAll.prodaja_ulaznica_e86bb419', 'Prodaja ulaznica') }}</h2>
      <h2 class="h-section">{{ adminText('organizationAll.priredbe_b0db3b62', 'Priredbe') }}</h2>
      <div
        v-if="report && report.ticketsGroupedByTitle && report.ticketsGroupedByTitle.length"
        class="card"
      >
        <div v-for="ev in report.ticketsGroupedByTitle" :key="ev.title" class="panel">
          <div class="panel-h">{{ ev.title }}</div>

          <template v-for="sp in ev.salePoints || []">
            <div :key="'event-sale-point-' + ev.title + '-' + sp.salePoint" class="row bold">
              {{ sp.salePoint }}
            </div>
            <div v-for="pt in sp.paymentTypeGroups || []" :key="pt.paymentType" class="row">
              <div class="grow">{{ formatPaymentType(pt) }}{{ formatGiftCardNote(pt) }}</div>
              <div class="qty">{{ formatCount(pt.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
              <div class="amt">{{ formatPaymentAmount(pt) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
            </div>
            <div :key="'event-sale-point-total-' + ev.title + '-' + sp.salePoint" class="row total">
              <div class="grow text-right">{{ adminText('organizationAll.ukupno_63e67e47', 'Ukupno') }}</div>
              <div class="qty bold">{{ formatCount(sumCounts(sp.paymentTypeGroups)) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
              <div class="amt bold">{{ formatAmount(sumTotals(sp.paymentTypeGroups)) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
            </div>
          </template>

          <div class="row grand-total">
            <div class="grow text-right bold">{{ adminText('organizationAll.sve_ukupno_5861f223', 'Sve ukupno') }}</div>
            <div class="qty bold">{{ formatCount(sumEventCounts(ev)) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
            <div class="amt bold">{{ formatAmount(sumEventTotals(ev)) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
          </div>
          <div v-if="sumEventGiftCardAmounts(ev)" class="row muted">
            <div class="grow text-right">{{ adminText('organizationAll.pla_eno_poklon_karticom_nije_uklju_eno_u_ukup_b9351d37', 'Plaćeno poklon karticom (nije uključeno u ukupno)') }}</div>
            <div class="amt">{{ formatAmount(sumEventGiftCardAmounts(ev)) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
          </div>
        </div>

        <div v-if="report && report.ticketsGroupedByTitle && report.ticketsGroupedByTitle.length">
          <div class="row-no-border grand-total">
            <div class="grow text-right bold">{{ adminText('organizationAll.ukupno_prodano_a674138e', 'Ukupno prodano') }}</div>
            <div class="qty bold">
              {{ formatCount(sumAllEventsSoldCounts(report.ticketsGroupedByTitle)) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}
            </div>
            <div class="amt bold">
              {{ formatAmount(sumAllEventsSoldTotals(report.ticketsGroupedByTitle)) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}
            </div>
          </div>
          <div class="row-no-border muted">
            <div class="grow text-right">{{ adminText('organizationAll.ukupno_stornirano_9757c825', 'Ukupno stornirano') }}</div>
            <div class="qty">
              {{ formatCount(sumAllEventsRefundCounts(report.ticketsGroupedByTitle)) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}
            </div>
            <div class="amt">
              {{ formatAmount(sumAllEventsRefundTotals(report.ticketsGroupedByTitle)) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}
            </div>
          </div>
          <div class="row-no-border grand-total">
            <div class="grow text-right bold">{{ adminText('organizationAll.ukupno_63e67e47', 'Ukupno') }}</div>
            <div class="qty bold">
              {{
                formatCount(
                  sumAllEventsSoldCounts(report.ticketsGroupedByTitle) +
                    sumAllEventsRefundCounts(report.ticketsGroupedByTitle),
                )
              }}
              {{ adminText('organizationAll.kom_85864f4c', 'kom') }}
            </div>
            <div class="amt bold">
              {{
                formatAmount(
                  sumAllEventsSoldTotals(report.ticketsGroupedByTitle) +
                    sumAllEventsRefundTotals(report.ticketsGroupedByTitle),
                )
              }}
              {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}
            </div>
          </div>
          <div v-if="sumAllEventsGiftCardAmounts(report.ticketsGroupedByTitle)" class="row-no-border muted">
            <div class="grow text-right">{{ adminText('organizationAll.pla_eno_poklon_karticom_nije_uklju_eno_u_ukup_b9351d37', 'Plaćeno poklon karticom (nije uključeno u ukupno)') }}</div>
            <div class="amt">
              {{ formatAmount(sumAllEventsGiftCardAmounts(report.ticketsGroupedByTitle)) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="placeholder">{{ adminText('organizationAll.nema_podataka_9c5ea060', 'Nema podataka') }}</div>

      <h2 class="h-section">{{ adminText('organizationAll.ostali_promet_prodajnih_mjesta_280b0e97', 'Ostali promet prodajnih mjesta') }}</h2>
      <div
        v-if="
          report &&
            report.otherSalesGroupedByPaymentType &&
            report.otherSalesGroupedByPaymentType.length
        "
        class="card"
      >
        <div
          v-for="pg in (report && report.otherSalesGroupedByPaymentType) || []"
          :key="pg.paymentType"
          class="panel"
        >
          <div class="panel-h">{{ formatPaymentType(pg) }}</div>

          <template v-for="sp in pg.salePoints || []">
            <div :key="'other-sale-point-' + pg.paymentType + '-' + sp.salePoint" class="row bold">
              {{ sp.salePoint }}
            </div>
            <div v-for="it in sp.items || []" :key="it.name" class="row">
              <div class="grow">{{ it.name }}{{ formatGiftCardNote(it) }}</div>
              <div class="qty">{{ formatCount(it.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
              <div class="amt">{{ formatPaymentAmount(it) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
            </div>
            <div :key="'other-sale-point-total-' + pg.paymentType + '-' + sp.salePoint" class="row total">
              <div class="grow text-right">{{ adminText('organizationAll.ukupno_63e67e47', 'Ukupno') }}</div>
              <div class="qty bold">{{ formatCount(sumItemsCount(sp.items)) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
              <div class="amt bold">{{ formatAmount(sumItemsTotal(sp.items)) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
            </div>
          </template>

          <div class="row grand-total">
            <div class="grow text-right bold">{{ adminText('organizationAll.sve_ukupno_5861f223', 'Sve ukupno') }}</div>
            <div class="qty bold">{{ formatCount(sumOtherPaymentTypeCounts(pg)) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
            <div class="amt bold">{{ formatAmount(sumOtherPaymentTypeTotals(pg)) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
          </div>
        </div>

        <div
          v-if="
            report &&
              report.otherSalesGroupedByPaymentType &&
              report.otherSalesGroupedByPaymentType.length
          "
        >
          <div class="row-no-border grand-total">
            <div class="grow text-right bold">{{ adminText('organizationAll.ukupno_ostalo_684b6b0f', 'Ukupno ostalo') }}</div>
            <div class="qty bold">
              {{
                formatCount(sumAllOtherByPaymentTypeCounts(report.otherSalesGroupedByPaymentType))
              }}
              {{ adminText('organizationAll.kom_85864f4c', 'kom') }}
            </div>
            <div class="amt bold">
              {{
                formatAmount(sumAllOtherByPaymentTypeTotals(report.otherSalesGroupedByPaymentType))
              }}
              {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="placeholder">{{ adminText('organizationAll.nema_podataka_9c5ea060', 'Nema podataka') }}</div>

      <h2 v-if="report && report.refunds && report.refunds.length" class="h-section">
        {{ adminText('organizationAll.storniranja_c5bd3b98', 'Storniranja') }}
      </h2>
      <div v-if="report && report.refunds && report.refunds.length" class="table card">
        <div class="t-row t-head">
          <div class="t-cell grow">{{ adminText('organizationAll.vrijeme_2cc59fd5', 'Vrijeme') }}</div>
          <div class="t-cell grow">{{ adminText('organizationAll.operater_narud_be_55609ffe', 'Operater narudžbe') }}</div>
          <div class="t-cell grow">{{ adminText('organizationAll.stornirao_3cf41d80', 'Stornirao') }}</div>
          <div class="t-cell w-100">{{ adminText('organizationAll.priredba_proizvod_8ec342b4', 'Priredba/Proizvod') }}</div>
          <div class="t-cell w-100">{{ adminText('organizationAll.sredstvo_7c6e6a93', 'Sredstvo') }}</div>
          <div class="t-cell w-100 right">{{ adminText('organizationAll.koli_ina_2624ed1b', 'Količina') }}</div>
          <div class="t-cell w-100 right">{{ adminText('organizationAll.iznos_43a4f456', 'Iznos') }}</div>
        </div>
        <div v-for="(r, idx) in report.refunds" :key="idx" class="t-row">
          <div class="t-cell grow">{{ formatDateTime(r.createdAt) }}</div>
          <div class="t-cell grow">{{ r.salePoint }}</div>
          <div class="t-cell grow">{{ r.refundedBy }}</div>
          <div class="t-cell w-100">{{ r.item }}</div>
          <div class="t-cell w-100">{{ formatPaymentType(r.paymentType) }}</div>
          <div class="t-cell w-100 right">{{ formatCount(r.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
          <div class="t-cell w-100 right">{{ formatAmount(r.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
        </div>
      </div>

      <h2 v-if="orderFormRows.length" class="h-section">{{ adminText('organizationAll.narud_benice_36b96b03', 'Narudžbenice') }}</h2>
      <div v-if="orderFormRows.length" class="table card">
        <div class="t-row t-head">
          <div class="t-cell grow">{{ adminText('organizationAll.blagajna_eb719c57', 'Blagajna') }}</div>
          <div class="t-cell w-100 right">{{ adminText('organizationAll.koli_ina_2624ed1b', 'Količina') }}</div>
          <div class="t-cell w-100 right">{{ adminText('organizationAll.iznos_43a4f456', 'Iznos') }}</div>
        </div>
        <div v-for="row in orderFormRows" :key="row.salePoint" class="t-row">
          <div class="t-cell grow">{{ row.salePoint }}</div>
          <div class="t-cell w-100 right">{{ formatCount(row.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
          <div class="t-cell w-100 right">{{ formatAmount(row.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
        </div>
      </div>

      <h2 v-if="recapSalePoints && recapSalePoints.length" class="h-section">
        {{ adminText('organizationAll.rekapitulacija_fizi_ke_prodaje_po_na_inu_pla__a62d7f7e', 'Rekapitulacija fizičke prodaje po načinu plaćanja (ulaznice, proizvodi, pretplate i članstva)') }}
      </h2>
      <div v-if="recapSalePoints && recapSalePoints.length">
        <div v-for="recap in recapSalePoints" :key="recap.salePoint" class="card">
          <div class="panel">
            <div class="panel-h">{{ recap.salePoint }}</div>
            <div class="row bold">{{ adminText('organizationAll.gotovinsko_pla_anje_8953a8d4', 'Gotovinsko plaćanje') }}</div>
            <div class="row">
              <div class="grow">{{ adminText('organizationAll.gotovina_8581144d', 'Gotovina') }}</div>
              <div class="qty">{{ formatCount(recap.cash.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
              <div class="amt">{{ formatAmount(recap.cash.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
            </div>
            <div v-if="recap.cash.stornoCount || recap.cash.stornoTotal" class="row">
              <div class="grow">{{ adminText('organizationAll.storno_10dccb99', 'Storno') }}</div>
              <div class="qty">{{ formatCount(recap.cash.stornoCount) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
              <div class="amt">{{ formatAmount(recap.cash.stornoTotal) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
            </div>
            <div class="row total">
              <div class="grow text-right">{{ adminText('organizationAll.ukupno_63e67e47', 'Ukupno') }}</div>
              <div class="qty bold">
                {{ formatCount(recap.cash.count + recap.cash.stornoCount) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}
              </div>
              <div class="amt bold">
                {{ formatAmount(recap.cash.total + recap.cash.stornoTotal) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}
              </div>
            </div>

            <div class="row bold mt">{{ adminText('organizationAll.platne_kreditne_kartice_278ad9d6', 'Platne/kreditne kartice') }}</div>
            <div v-for="(card, cardName) in recap.cards" :key="cardName" class="row">
              <div class="grow">{{ formatPaymentType(cardName) }}</div>
              <div class="qty">{{ formatCount(card.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
              <div class="amt">{{ formatAmount(card.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
            </div>
            <div class="row total">
              <div class="grow text-right">{{ adminText('organizationAll.ukupno_63e67e47', 'Ukupno') }}</div>
              <div class="qty bold">{{ formatCount(recap.cardsTotal.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
              <div class="amt bold">{{ formatAmount(recap.cardsTotal.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
            </div>

            <div v-if="recap.kulturnaIskaznica.total.count" class="row bold mt">
              {{ adminText('organizationAll.kulturna_iskaznica_d83fd25b', 'Kulturna iskaznica') }}
            </div>
            <div v-if="recap.kulturnaIskaznica.full.count" class="row">
              <div class="grow">{{ adminText('organizationAll.kulturna_iskaznica_d83fd25b', 'Kulturna iskaznica') }}</div>
              <div class="qty">{{ formatCount(recap.kulturnaIskaznica.full.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
              <div class="amt">{{ formatAmount(recap.kulturnaIskaznica.full.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
            </div>
            <div v-if="recap.kulturnaIskaznica.cash.count" class="row">
              <div class="grow">{{ adminText('organizationAll.gotovina_kulturna_iskaznica_a24a6bad', 'Gotovina / Kulturna iskaznica') }}</div>
              <div class="qty">{{ formatCount(recap.kulturnaIskaznica.cash.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
              <div class="amt">{{ formatAmount(recap.kulturnaIskaznica.cash.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
            </div>
            <div v-if="recap.kulturnaIskaznica.card.count" class="row">
              <div class="grow">{{ adminText('organizationAll.kartica_kulturna_iskaznica_fa49f0b2', 'Kartica / Kulturna iskaznica') }}</div>
              <div class="qty">{{ formatCount(recap.kulturnaIskaznica.card.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
              <div class="amt">{{ formatAmount(recap.kulturnaIskaznica.card.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
            </div>
            <div v-if="recap.kulturnaIskaznica.online.count" class="row">
              <div class="grow">{{ adminText('organizationAll.online_kulturna_iskaznica_6b8e7946', 'Online / Kulturna iskaznica') }}</div>
              <div class="qty">{{ formatCount(recap.kulturnaIskaznica.online.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
              <div class="amt">{{ formatAmount(recap.kulturnaIskaznica.online.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
            </div>
            <div v-if="recap.kulturnaIskaznica.total.count" class="row total">
              <div class="grow text-right">{{ adminText('organizationAll.ukupno_63e67e47', 'Ukupno') }}</div>
              <div class="qty bold">{{ formatCount(recap.kulturnaIskaznica.total.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
              <div class="amt bold">{{ formatAmount(recap.kulturnaIskaznica.total.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
            </div>

            <div class="row bold mt">{{ adminText('organizationAll.narud_benice_36b96b03', 'Narudžbenice') }}</div>
            <div class="row">
              <div class="grow">{{ adminText('organizationAll.narud_benica_3697d831', 'Narudžbenica') }}</div>
              <div class="qty">{{ formatCount(recap.orderForm.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
              <div class="amt">{{ formatAmount(recap.orderForm.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
            </div>
            <div v-if="recap.orderForm.stornoCount || recap.orderForm.stornoTotal" class="row">
              <div class="grow">{{ adminText('organizationAll.storno_10dccb99', 'Storno') }}</div>
              <div class="qty">{{ formatCount(recap.orderForm.stornoCount) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
              <div class="amt">{{ formatAmount(recap.orderForm.stornoTotal) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
            </div>
            <div class="row total">
              <div class="grow text-right">{{ adminText('organizationAll.ukupno_63e67e47', 'Ukupno') }}</div>
              <div class="qty bold">
                {{ formatCount(recap.orderForm.count + recap.orderForm.stornoCount) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}
              </div>
              <div class="amt bold">
                {{ formatAmount(recap.orderForm.total + recap.orderForm.stornoTotal) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}
              </div>
            </div>

            <div class="row grand-total">
              <div class="grow text-right bold">{{ adminText('organizationAll.sve_ukupno_5861f223', 'Sve ukupno') }}</div>
              <div class="qty bold">{{ formatCount(recap.grandTotal.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
              <div class="amt bold">{{ formatAmount(recap.grandTotal.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
            </div>
          </div>
        </div>
      </div>
      <h2 v-if="totalRecap" class="h-section">
        {{ adminText('organizationAll.rekapitulacija_fizi_ke_prodaje_po_na_inu_pla__8f96b45e', 'Rekapitulacija fizičke prodaje po načinu plaćanja za sve priredbe skupa (ulaznice, proizvodi, pretplate i članstva)') }}
      </h2>
      <div v-if="totalRecap" class="card">
        <div class="panel">
          <div class="panel-h">{{ adminText('organizationAll.sve_priredbe_d559513c', 'Sve priredbe') }}</div>
          <div class="row bold">{{ adminText('organizationAll.gotovinsko_pla_anje_8953a8d4', 'Gotovinsko plaćanje') }}</div>
          <div class="row">
            <div class="grow">{{ adminText('organizationAll.gotovina_8581144d', 'Gotovina') }}</div>
            <div class="qty">{{ formatCount(totalRecap.cash.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
            <div class="amt">{{ formatAmount(totalRecap.cash.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
          </div>
          <div v-if="totalRecap.cash.stornoCount || totalRecap.cash.stornoTotal" class="row">
            <div class="grow">{{ adminText('organizationAll.storno_10dccb99', 'Storno') }}</div>
            <div class="qty">{{ formatCount(totalRecap.cash.stornoCount) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
            <div class="amt">{{ formatAmount(totalRecap.cash.stornoTotal) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
          </div>
          <div class="row total">
            <div class="grow text-right">{{ adminText('organizationAll.ukupno_63e67e47', 'Ukupno') }}</div>
            <div class="qty bold">
              {{ formatCount(totalRecap.cash.count + totalRecap.cash.stornoCount) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}
            </div>
            <div class="amt bold">
              {{ formatAmount(totalRecap.cash.total + totalRecap.cash.stornoTotal) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}
            </div>
          </div>

          <div class="row bold mt">{{ adminText('organizationAll.platne_kreditne_kartice_278ad9d6', 'Platne/kreditne kartice') }}</div>
          <div v-for="(card, cardName) in totalRecap.cards" :key="cardName" class="row">
            <div class="grow">{{ formatPaymentType(cardName) }}</div>
            <div class="qty">{{ formatCount(card.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
            <div class="amt">{{ formatAmount(card.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
          </div>
          <div class="row total">
            <div class="grow text-right">{{ adminText('organizationAll.ukupno_63e67e47', 'Ukupno') }}</div>
            <div class="qty bold">{{ formatCount(totalRecap.cardsTotal.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
            <div class="amt bold">{{ formatAmount(totalRecap.cardsTotal.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
          </div>

          <div v-if="totalRecap.kulturnaIskaznica.total.count" class="row bold mt">
            {{ adminText('organizationAll.kulturna_iskaznica_d83fd25b', 'Kulturna iskaznica') }}
          </div>
          <div v-if="totalRecap.kulturnaIskaznica.full.count" class="row">
            <div class="grow">{{ adminText('organizationAll.kulturna_iskaznica_d83fd25b', 'Kulturna iskaznica') }}</div>
            <div class="qty">{{ formatCount(totalRecap.kulturnaIskaznica.full.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
            <div class="amt">{{ formatAmount(totalRecap.kulturnaIskaznica.full.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
          </div>
          <div v-if="totalRecap.kulturnaIskaznica.cash.count" class="row">
            <div class="grow">{{ adminText('organizationAll.gotovina_kulturna_iskaznica_a24a6bad', 'Gotovina / Kulturna iskaznica') }}</div>
            <div class="qty">{{ formatCount(totalRecap.kulturnaIskaznica.cash.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
            <div class="amt">{{ formatAmount(totalRecap.kulturnaIskaznica.cash.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
          </div>
          <div v-if="totalRecap.kulturnaIskaznica.card.count" class="row">
            <div class="grow">{{ adminText('organizationAll.kartica_kulturna_iskaznica_fa49f0b2', 'Kartica / Kulturna iskaznica') }}</div>
            <div class="qty">{{ formatCount(totalRecap.kulturnaIskaznica.card.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
            <div class="amt">{{ formatAmount(totalRecap.kulturnaIskaznica.card.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
          </div>
          <div v-if="totalRecap.kulturnaIskaznica.online.count" class="row">
            <div class="grow">{{ adminText('organizationAll.online_kulturna_iskaznica_6b8e7946', 'Online / Kulturna iskaznica') }}</div>
            <div class="qty">{{ formatCount(totalRecap.kulturnaIskaznica.online.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
            <div class="amt">{{ formatAmount(totalRecap.kulturnaIskaznica.online.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
          </div>
          <div v-if="totalRecap.kulturnaIskaznica.total.count" class="row total">
            <div class="grow text-right">{{ adminText('organizationAll.ukupno_63e67e47', 'Ukupno') }}</div>
            <div class="qty bold">{{ formatCount(totalRecap.kulturnaIskaznica.total.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
            <div class="amt bold">{{ formatAmount(totalRecap.kulturnaIskaznica.total.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
          </div>

          <div class="row bold mt">{{ adminText('organizationAll.narud_benice_36b96b03', 'Narudžbenice') }}</div>
          <div class="row">
            <div class="grow">{{ adminText('organizationAll.narud_benica_3697d831', 'Narudžbenica') }}</div>
            <div class="qty">{{ formatCount(totalRecap.orderForm.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
            <div class="amt">{{ formatAmount(totalRecap.orderForm.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
          </div>
          <div
            v-if="totalRecap.orderForm.stornoCount || totalRecap.orderForm.stornoTotal"
            class="row"
          >
            <div class="grow">{{ adminText('organizationAll.storno_10dccb99', 'Storno') }}</div>
            <div class="qty">{{ formatCount(totalRecap.orderForm.stornoCount) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
            <div class="amt">{{ formatAmount(totalRecap.orderForm.stornoTotal) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
          </div>
          <div class="row total">
            <div class="grow text-right">{{ adminText('organizationAll.ukupno_63e67e47', 'Ukupno') }}</div>
            <div class="qty bold">
              {{ formatCount(totalRecap.orderForm.count + totalRecap.orderForm.stornoCount) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}
            </div>
            <div class="amt bold">
              {{ formatAmount(totalRecap.orderForm.total + totalRecap.orderForm.stornoTotal) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}
            </div>
          </div>

          <div class="row grand-total">
            <div class="grow text-right bold">{{ adminText('organizationAll.sve_ukupno_5861f223', 'Sve ukupno') }}</div>
            <div class="qty bold">{{ formatCount(totalRecap.grandTotal.count) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
            <div class="amt bold">{{ formatAmount(totalRecap.grandTotal.total) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
          </div>
        </div>
      </div>
      <div v-if="recapSalePoints && recapSalePoints.length">
        <div class="row-no-border grand-total">
          <div class="grow text-right bold">{{ adminText('organizationAll.ukupno_prodano_a674138e', 'Ukupno prodano') }}</div>
          <div class="qty bold">{{ formatCount(sumAllRecapSoldCounts(recapSalePoints)) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
          <div class="amt bold">{{ formatAmount(sumAllRecapSoldTotals(recapSalePoints)) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
        </div>
        <div class="row-no-border muted">
          <div class="grow text-right">{{ adminText('organizationAll.ukupno_stornirano_9757c825', 'Ukupno stornirano') }}</div>
          <div class="qty">{{ formatCount(sumAllRecapRefundCounts(recapSalePoints)) }} {{ adminText('organizationAll.kom_85864f4c', 'kom') }}</div>
          <div class="amt">{{ formatAmount(sumAllRecapRefundTotals(recapSalePoints)) }} {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}</div>
        </div>
        <div class="row-no-border grand-total">
          <div class="grow text-right bold">{{ adminText('organizationAll.ukupno_63e67e47', 'Ukupno') }}</div>
          <div class="qty bold">
            {{
              formatCount(
                sumAllRecapSoldCounts(recapSalePoints) + sumAllRecapRefundCounts(recapSalePoints),
              )
            }}
            {{ adminText('organizationAll.kom_85864f4c', 'kom') }}
          </div>
          <div class="amt bold">
            {{
              formatAmount(
                sumAllRecapSoldTotals(recapSalePoints) + sumAllRecapRefundTotals(recapSalePoints),
              )
            }}
            {{ adminText('organizationAll.eur_27eae1ff', 'eur') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import moment from 'moment'

export default {
  mixins: [OrganizationLocalization],
  props: {
    report: Object,
    organization: Object,
    from: String,
    to: String,
    filterLabels: Array,
  },
  data() {
    return {}
  },
  computed: {
    salePointsList() {
      const set = new Set()
      const tickets = (this.report && this.report.ticketsGroupedByTitle) || []
      const other = (this.report && this.report.otherSalesGroupedByPaymentType) || []
      for (const ev of tickets) {
        for (const sp of ev.salePoints || []) {
          if (sp && sp.salePoint) set.add(sp.salePoint)
        }
      }
      for (const pg of other) {
        for (const sp of pg.salePoints || []) {
          if (sp && sp.salePoint) set.add(sp.salePoint)
        }
      }

      return Array.from(set)
    },
    recapSalePoints() {
      const recaps = []
      const tickets = (this.report && this.report.ticketsGroupedByTitle) || []
      const other = (this.report && this.report.otherSalesGroupedByPaymentType) || []

      const ensureRecap = salePoint => {
        let recap = recaps.find(r => r.salePoint === salePoint)
        if (!recap) {
          recap = {
            salePoint,
            cash: { count: 0, total: 0, stornoCount: 0, stornoTotal: 0 },
            cards: {},
            cardsTotal: { count: 0, total: 0 },
            orderForm: { count: 0, total: 0, stornoCount: 0, stornoTotal: 0 },
            kulturnaIskaznica: {
              total: { count: 0, total: 0 },
              full: { count: 0, total: 0 },
              cash: { count: 0, total: 0 },
              card: { count: 0, total: 0 },
              online: { count: 0, total: 0 },
            },
            grandTotal: { count: 0, total: 0 },
          }
          recaps.push(recap)
        }

        return recap
      }

      const isOnline = name => (name || '').toLowerCase() === 'online'

      // tickets by title -> sale points -> payment type groups
      for (const ev of tickets) {
        for (const sp of ev.salePoints || []) {
          if (isOnline(sp.salePoint)) continue
          const recap = ensureRecap(sp.salePoint)
          for (const pt of sp.paymentTypeGroups || []) {
            const label = pt.paymentType || ''
            const count = Number(pt.count) || 0
            const total = Number(pt.total) || 0
            const isStorno = /^storno/i.test(label)
            const isKulturnaIskaznica = this.addKulturnaIskaznicaToRecap(recap, pt, count, total)
            if (
              !isKulturnaIskaznica ||
              (this.isMixedKulturnaIskaznicaPayment(pt) && !this.isKulturnaIskaznicaFilter())
            ) {
              this.addRemainderToRecap(recap, pt, count, total, isStorno)
            }
          }
        }
      }

      // other sales grouped by payment type -> sale points -> items
      for (const pg of other) {
        const label = pg.paymentType || ''
        const isStorno = /^storno/i.test(label)
        for (const sp of pg.salePoints || []) {
          if (isOnline(sp.salePoint)) continue
          const recap = ensureRecap(sp.salePoint)
          const counts = (sp.items || []).reduce((acc, it) => acc + (Number(it.count) || 0), 0)
          const totals = (sp.items || []).reduce((acc, it) => acc + this.getPaymentTotalForSum(it), 0)
          const groupItem = {
            paymentType: label,
            count: counts,
            total: totals,
            kiAmount: this.formatAmount((sp.items || []).reduce((acc, it) => acc + this.getKiAmount(it), 0)),
            kiRemainderAmount: this.formatAmount(
              (sp.items || []).reduce((acc, it) => acc + this.getKiRemainderAmount(it), 0),
            ),
            kiMixedPayment: (sp.items || []).some(it => this.isMixedKulturnaIskaznicaPayment(it)),
          }

          const isKulturnaIskaznica = this.addKulturnaIskaznicaToRecap(recap, groupItem, counts, totals)
          if (
            !isKulturnaIskaznica ||
            (this.isMixedKulturnaIskaznicaPayment(groupItem) && !this.isKulturnaIskaznicaFilter())
          ) {
            this.addRemainderToRecap(recap, groupItem, counts, totals, isStorno)
          }
        }
      }

      // finalize
      for (const recap of recaps) {
        const cardKeys = Object.keys(recap.cards)
        recap.cardsTotal.count = cardKeys.reduce(
          (a, k) => a + (Number(recap.cards[k].count) || 0),
          0,
        )
        recap.cardsTotal.total = cardKeys.reduce(
          (a, k) => a + (Number(recap.cards[k].total) || 0),
          0,
        )

        recap.grandTotal.count =
          (Number(recap.cash.count) || 0) +
          (Number(recap.cash.stornoCount) || 0) +
          (Number(recap.cardsTotal.count) || 0) +
          (Number(recap.orderForm.count) || 0) +
          (Number(recap.orderForm.stornoCount) || 0) +
          (Number(recap.kulturnaIskaznica.total.count) || 0)

        recap.grandTotal.total =
          (Number(recap.cash.total) || 0) +
          (Number(recap.cash.stornoTotal) || 0) +
          (Number(recap.cardsTotal.total) || 0) +
          (Number(recap.orderForm.total) || 0) +
          (Number(recap.orderForm.stornoTotal) || 0) +
          (Number(recap.kulturnaIskaznica.total.total) || 0)
      }

      return recaps
    },
    totalRecap() {
      const recaps = this.recapSalePoints || []
      if (!recaps.length) return null
      const total = {
        salePoint: 'ALL',
        cash: { count: 0, total: 0, stornoCount: 0, stornoTotal: 0 },
        cards: {},
        cardsTotal: { count: 0, total: 0 },
        orderForm: { count: 0, total: 0, stornoCount: 0, stornoTotal: 0 },
        kulturnaIskaznica: {
          total: { count: 0, total: 0 },
          full: { count: 0, total: 0 },
          cash: { count: 0, total: 0 },
          card: { count: 0, total: 0 },
          online: { count: 0, total: 0 },
        },
        grandTotal: { count: 0, total: 0 },
      }

      for (const r of recaps) {
        total.cash.count += Number(r.cash.count) || 0
        total.cash.total += Number(r.cash.total) || 0
        total.cash.stornoCount += Number(r.cash.stornoCount) || 0
        total.cash.stornoTotal += Number(r.cash.stornoTotal) || 0

        for (const [k, v] of Object.entries(r.cards || {})) {
          if (!total.cards[k]) total.cards[k] = { count: 0, total: 0 }
          total.cards[k].count += Number(v.count) || 0
          total.cards[k].total += Number(v.total) || 0
        }

        total.orderForm.count += Number(r.orderForm.count) || 0
        total.orderForm.total += Number(r.orderForm.total) || 0
        total.orderForm.stornoCount += Number(r.orderForm.stornoCount) || 0
        total.orderForm.stornoTotal += Number(r.orderForm.stornoTotal) || 0

        for (const key of ['total', 'full', 'cash', 'card', 'online']) {
          total.kulturnaIskaznica[key].count += Number(r.kulturnaIskaznica[key].count) || 0
          total.kulturnaIskaznica[key].total += Number(r.kulturnaIskaznica[key].total) || 0
        }
      }

      const cardKeys = Object.keys(total.cards)
      total.cardsTotal.count = cardKeys.reduce((a, k) => a + (Number(total.cards[k].count) || 0), 0)
      total.cardsTotal.total = cardKeys.reduce((a, k) => a + (Number(total.cards[k].total) || 0), 0)

      total.grandTotal.count =
        (Number(total.cash.count) || 0) +
        (Number(total.cash.stornoCount) || 0) +
        (Number(total.cardsTotal.count) || 0) +
        (Number(total.orderForm.count) || 0) +
        (Number(total.orderForm.stornoCount) || 0) +
        (Number(total.kulturnaIskaznica.total.count) || 0)

      total.grandTotal.total =
        (Number(total.cash.total) || 0) +
        (Number(total.cash.stornoTotal) || 0) +
        (Number(total.cardsTotal.total) || 0) +
        (Number(total.orderForm.total) || 0) +
        (Number(total.orderForm.stornoTotal) || 0) +
        (Number(total.kulturnaIskaznica.total.total) || 0)

      return total
    },
    orderFormRows() {
      const rowsMap = new Map()
      const report = this.report || {}
      const tickets = report.ticketsGroupedByTitle || []
      for (const ev of tickets) {
        for (const sp of ev.salePoints || []) {
          for (const pt of sp.paymentTypeGroups || []) {
            if (pt.paymentType === 'ORDER_FORM') {
              const key = sp.salePoint
              const prev = rowsMap.get(key) || { salePoint: key, count: 0, total: 0 }
              prev.count += Number(pt.count) || 0
              prev.total += Number(pt.total) || 0
              rowsMap.set(key, prev)
            }
          }
        }
      }

      const other = report.otherSalesGroupedByPaymentType || []
      for (const pg of other) {
        if (pg.paymentType === 'ORDER_FORM') {
          for (const sp of pg.salePoints || []) {
            const key = sp.salePoint
            const prev = rowsMap.get(key) || { salePoint: key, count: 0, total: 0 }
            prev.count += this.sumItemsCount(sp.items)
            prev.total += this.sumItemsTotal(sp.items)
            rowsMap.set(key, prev)
          }
        }
      }

      return Array.from(rowsMap.values())
    },
    formattedDateRange() {
      const from = this.from || 'All time'
      const to = this.to || ''

      return to ? `${from} – ${to}` : from
    },
  },
  methods: {
    normalizeArray(value) {
      if (!value) return undefined
      if (Array.isArray(value)) return value

      return String(value)
        .split(',')
        .map(v => v.trim())
        .filter(Boolean)
    },
    normalizeNumberArray(value) {
      const arr = this.normalizeArray(value)

      return arr ? arr.map(v => Number(v)).filter(n => !Number.isNaN(n)) : undefined
    },
    formatDateTime(value) {
      if (!value) return ''

      return moment(value).format('DD.MM.YYYY. HH:mm')
    },
    formatPaymentType(payment) {
      if (!payment) return ''
      const item = typeof payment === 'object' ? payment : { paymentType: payment }
      let value = item.paymentType || ''
      if (this.isKulturnaIskaznicaPayment(item)) {
        if (this.isMixedKulturnaIskaznicaPayment(item)) {
          if (value.includes('_CASH') || value.includes('CASH')) return 'Gotovina / Kulturna iskaznica'
          if (value.includes(' / KULTURNA_ISKAZNICA')) {
            return `${value.replace(' / KULTURNA_ISKAZNICA', '')} / Kulturna iskaznica`
          }
          if (value.includes('_CARD')) return 'Kartica / Kulturna iskaznica'

          return 'Online / Kulturna iskaznica'
        }

        return 'Kulturna iskaznica'
      }
      if (value.includes('CASH')) {
        value = value.replace('CASH', 'Gotovina').replace('GIFT_CARD', 'poklon kartica')
      }
      if (value.includes('GIFT_CARD')) {
        value = value.replace('GIFT_CARD', 'Poklon kartica')
      }
      if (value === 'CARD') {
        return 'Kartica'
      }
      if (value === 'ORDER_FORM') {
        return 'Narudžbenica'
      }
      if (value === 'REFUND') {
        return 'Storno'
      }
      if (value.includes('ONLINE')) {
        return value.replace('ONLINE', 'Online')
      }

      return value
    },
    formatGiftCardNote(item) {
      const amount = Number(item && item.giftCardAmount) || 0

      return amount ? ` (s poklon kartice: ${this.formatAmount(amount)} eur)` : ''
    },
    sumGiftCardAmounts(items) {
      return (items || []).reduce((acc, it) => acc + (Number(it.giftCardAmount) || 0), 0)
    },
    sumEventGiftCardAmounts(ev) {
      return (ev.salePoints || []).reduce(
        (acc, sp) => acc + this.sumGiftCardAmounts(sp.paymentTypeGroups),
        0,
      )
    },
    sumAllEventsGiftCardAmounts(groups) {
      return (groups || []).reduce((acc, ev) => acc + this.sumEventGiftCardAmounts(ev), 0)
    },
    formatCount(n) {
      const num = Number(n) || 0

      return Math.round(num)
    },
    formatAmount(n) {
      const num = Number(n) || 0

      return num.toFixed(2)
    },
    parseMoney(amount) {
      if (amount === null || amount === undefined || amount === '') return 0

      return Number(String(amount).replace('EUR ', '')) || 0
    },
    getKiAmount(item) {
      return this.parseMoney(item && item.kiAmount)
    },
    getKiRemainderAmount(item) {
      const explicitRemainder = this.parseMoney(item && item.kiRemainderAmount)
      if (explicitRemainder > 0) return explicitRemainder
      if (!this.isMixedKulturnaIskaznicaPayment(item)) return 0

      return Math.max(Number((item && item.total) || 0) - this.getKiAmount(item), 0)
    },
    isKulturnaIskaznicaPayment(item) {
      if (!item) return false
      const paymentType = typeof item === 'string' ? item : item.paymentType

      return (
        paymentType === 'KULTURNA_ISKAZNICA' ||
        String(paymentType || '').includes('KULTURNA_ISKAZNICA') ||
        this.getKiAmount(item) > 0
      )
    },
    isMixedKulturnaIskaznicaPayment(item) {
      const paymentType = typeof item === 'string' ? item : item && item.paymentType

      return (
        Boolean(item && item.kiMixedPayment) ||
        String(paymentType || '').includes('_CASH') ||
        String(paymentType || '').includes('_ONLINE') ||
        String(paymentType || '').includes(' / KULTURNA_ISKAZNICA') ||
        (this.getKiAmount(item) > 0 && this.parseMoney(item && item.kiRemainderAmount) > 0)
      )
    },
    isKulturnaIskaznicaFilter() {
      return this.$route && this.$route.query && this.$route.query.paymentType === 'KULTURNA_ISKAZNICA'
    },
    getPaymentTotalForSum(item) {
      if (this.isKulturnaIskaznicaFilter() && this.isKulturnaIskaznicaPayment(item)) {
        return this.getKiAmount(item) || Number((item && item.total) || 0)
      }

      return Number((item && item.total) || 0)
    },
    formatPaymentAmount(item) {
      if (this.isKulturnaIskaznicaFilter() && this.isKulturnaIskaznicaPayment(item)) {
        return this.formatAmount(this.getKiAmount(item) || Number(item.total || 0))
      }
      if (this.isMixedKulturnaIskaznicaPayment(item)) {
        return `${this.formatAmount(this.getKiRemainderAmount(item))} eur / ${this.formatAmount(
          this.getKiAmount(item),
        )}`
      }

      return this.formatAmount(item && item.total)
    },
    sumCounts(items) {
      return (items || []).reduce((acc, it) => acc + (Number(it.count) || 0), 0)
    },
    sumTotals(items) {
      return (items || []).reduce((acc, it) => acc + this.getPaymentTotalForSum(it), 0)
    },
    sumItemsCount(items) {
      return (items || []).reduce((acc, it) => acc + (Number(it.count) || 0), 0)
    },
    sumItemsTotal(items) {
      return (items || []).reduce((acc, it) => acc + this.getPaymentTotalForSum(it), 0)
    },
    // totals within an event (across sale points)
    sumEventCounts(ev) {
      return (ev.salePoints || []).reduce(
        (acc, sp) => acc + this.sumCounts(sp.paymentTypeGroups || []),
        0,
      )
    },
    sumEventTotals(ev) {
      return (ev.salePoints || []).reduce(
        (acc, sp) => acc + this.sumTotals(sp.paymentTypeGroups || []),
        0,
      )
    },
    // sold vs refund across all events
    sumAllEventsSoldCounts(groups) {
      return (groups || []).reduce((totalAcc, ev) => {
        const perEvent = (ev.salePoints || []).reduce((spAcc, sp) => {
          const positives = (sp.paymentTypeGroups || []).filter(pt => Number(pt.count) > 0)

          return spAcc + this.sumCounts(positives)
        }, 0)

        return totalAcc + perEvent
      }, 0)
    },
    sumAllEventsSoldTotals(groups) {
      return (groups || []).reduce((totalAcc, ev) => {
        const perEvent = (ev.salePoints || []).reduce((spAcc, sp) => {
          const positives = (sp.paymentTypeGroups || []).filter(pt => Number(pt.total) > 0)

          return spAcc + this.sumTotals(positives)
        }, 0)

        return totalAcc + perEvent
      }, 0)
    },
    sumAllEventsRefundCounts(groups) {
      return (groups || []).reduce((totalAcc, ev) => {
        const perEvent = (ev.salePoints || []).reduce((spAcc, sp) => {
          const negatives = (sp.paymentTypeGroups || []).filter(pt => Number(pt.count) < 0)

          return spAcc + this.sumCounts(negatives)
        }, 0)

        return totalAcc + perEvent
      }, 0)
    },
    sumAllEventsRefundTotals(groups) {
      return (groups || []).reduce((totalAcc, ev) => {
        const perEvent = (ev.salePoints || []).reduce((spAcc, sp) => {
          const negatives = (sp.paymentTypeGroups || []).filter(pt => Number(pt.total) < 0)

          return spAcc + this.sumTotals(negatives)
        }, 0)

        return totalAcc + perEvent
      }, 0)
    },
    // other sales by payment type helpers
    sumOtherPaymentTypeCounts(pg) {
      return (pg.salePoints || []).reduce((acc, sp) => acc + this.sumItemsCount(sp.items || []), 0)
    },
    sumOtherPaymentTypeTotals(pg) {
      return (pg.salePoints || []).reduce((acc, sp) => acc + this.sumItemsTotal(sp.items || []), 0)
    },
    sumAllOtherByPaymentTypeCounts(groups) {
      return (groups || []).reduce((acc, g) => acc + this.sumOtherPaymentTypeCounts(g), 0)
    },
    sumAllOtherByPaymentTypeTotals(groups) {
      return (groups || []).reduce((acc, g) => acc + this.sumOtherPaymentTypeTotals(g), 0)
    },
    addKulturnaIskaznicaToRecap(recap, item, count, total) {
      if (!this.isKulturnaIskaznicaPayment(item)) return false

      const kiTotal = this.getKiAmount(item) || total
      const isMixed = this.isMixedKulturnaIskaznicaPayment(item)
      let key = 'full'
      if (isMixed && String(item.paymentType || '').includes('CASH')) key = 'cash'
      else if (isMixed && /card|visa|mastercard|maestro|diners|discover/i.test(item.paymentType || '')) key = 'card'
      else if (isMixed) key = 'online'

      recap.kulturnaIskaznica[key].count += count
      recap.kulturnaIskaznica[key].total += kiTotal
      recap.kulturnaIskaznica.total.count += count
      recap.kulturnaIskaznica.total.total += kiTotal

      return true
    },
    addRemainderToRecap(recap, item, count, total, isStorno) {
      const label = item.paymentType || ''
      const remainderTotal = this.isMixedKulturnaIskaznicaPayment(item)
        ? this.getKiRemainderAmount(item)
        : total

      if (label.includes('CASH')) {
        if (isStorno) {
          recap.cash.stornoCount += count
          recap.cash.stornoTotal += remainderTotal
        } else {
          recap.cash.count += count
          recap.cash.total += remainderTotal
        }
      } else if (label === 'ORDER_FORM') {
        if (isStorno) {
          recap.orderForm.stornoCount += count
          recap.orderForm.stornoTotal += remainderTotal
        } else {
          recap.orderForm.count += count
          recap.orderForm.total += remainderTotal
        }
      } else if (label === 'CARD' || /visa|mastercard|maestro|diners|discover|card/i.test(label)) {
        const key = label.replace(' / KULTURNA_ISKAZNICA', '')
        recap.cards[key] = recap.cards[key] || { count: 0, total: 0 }
        recap.cards[key].count += count
        recap.cards[key].total += remainderTotal
      }
    },
    // recap totals across sale points (excluding online)
    sumAllRecapSoldCounts(recaps) {
      return (recaps || []).reduce((acc, r) => {
        const cardsPositive = Object.values(r.cards || {}).reduce(
          (a, c) => a + (Number(c.count) > 0 ? Number(c.count) : 0),
          0,
        )

        return (
          acc +
          (Number(r.cash.count) || 0) +
          cardsPositive +
          (Number(r.orderForm.count) || 0) +
          (Number(r.kulturnaIskaznica && r.kulturnaIskaznica.total && r.kulturnaIskaznica.total.count) || 0)
        )
      }, 0)
    },
    sumAllRecapSoldTotals(recaps) {
      return (recaps || []).reduce((acc, r) => {
        const cardsPositive = Object.values(r.cards || {}).reduce(
          (a, c) => a + (Number(c.total) > 0 ? Number(c.total) : 0),
          0,
        )

        return (
          acc +
          (Number(r.cash.total) || 0) +
          cardsPositive +
          (Number(r.orderForm.total) || 0) +
          (Number(r.kulturnaIskaznica && r.kulturnaIskaznica.total && r.kulturnaIskaznica.total.total) || 0)
        )
      }, 0)
    },
    sumAllRecapRefundCounts(recaps) {
      return (recaps || []).reduce((acc, r) => {
        const cardsNegative = Object.values(r.cards || {}).reduce(
          (a, c) => a + (Number(c.count) < 0 ? Number(c.count) : 0),
          0,
        )

        return (
          acc +
          (Number(r.cash.stornoCount) || 0) +
          cardsNegative +
          (Number(r.orderForm.stornoCount) || 0)
        )
      }, 0)
    },
    sumAllRecapRefundTotals(recaps) {
      return (recaps || []).reduce((acc, r) => {
        const cardsNegative = Object.values(r.cards || {}).reduce(
          (a, c) => a + (Number(c.total) < 0 ? Number(c.total) : 0),
          0,
        )

        return (
          acc +
          (Number(r.cash.stornoTotal) || 0) +
          cardsNegative +
          (Number(r.orderForm.stornoTotal) || 0)
        )
      }, 0)
    },
  },
}
</script>

<style scoped>
.report-page {
  padding: 1.5rem;
}
.report-container {
  margin: 0 auto;
  max-width: 1120px;
  background: #fff;
}
.top-meta {
  color: #0277bd;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  line-height: 1.5;
  text-align: right;
}
.title-wrap {
  text-align: center;
  margin-top: 0.25rem;
}
.title {
  color: #0277bd;
  font-family: Raleway;
  font-size: 24px;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.72px;
  margin: 0;
}
.period {
  color: #0277bd;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  line-height: 1.5;
}
.org-info {
  color: #0277bd;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  line-height: 1.5;
  margin: 0.5rem 0 1rem 0;
}
.bold {
  font-weight: 700;
}
.filters {
  margin: 0;
  padding-left: 1.25rem;
}
.text-right {
  text-align: right;
}
.h-section {
  color: #0277bd;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  line-height: 1.5;
  margin: 1rem 0 0.5rem 0;
}
.card-h {
  background: #f5f5f5;
  color: #333333;
  font-family: 'Source Sans Pro';
  font-size: 12px;
  padding: 10px;
}
.panel {
  width: 100%;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 1rem;
}
.panel-h {
  background: #f5f5f5;
  color: #333333;
  font-family: 'Source Sans Pro';
  font-size: 12px;
  padding: 10px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-left: 1px solid #e6e6e6;
  border-right: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  color: #333333;
  font-family: 'Source Sans Pro';
  font-size: 12px;
}
.row-no-border {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  color: #333333;
  font-family: 'Source Sans Pro';
  font-size: 12px;
}
.row.bold {
  font-weight: 700;
}
.row.muted {
  color: #666666;
}
.row.mt {
  margin-top: 0.25rem;
}
.row.total {
  border-top: 1px solid #e6e6e6;
}
.row-no-border.grand-total,
.row.grand-total {
  border-top: 4px solid #e6e6e6;
}
.grow {
  flex: 1 1 auto;
}
.qty {
  width: 140px;
  text-align: right;
}
.amt {
  width: 140px;
  text-align: right;
}
.table .t-row {
  display: flex;
  border-left: 1px solid #e6e6e6;
  border-right: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
}
.table .t-head {
  background: #f5f5f5;
}
.table .t-cell {
  padding: 10px;
  color: #333333;
  font-family: 'Source Sans Pro';
  font-size: 12px;
}
.table .t-cell.right {
  text-align: right;
}
.table .t-cell.w-100 {
  width: 140px;
}
.placeholder {
  text-align: center;
  padding: 24px 16px;
  margin: 8px 0 16px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  font-family: 'Source Sans Pro';
  font-size: 13px;
  line-height: 1.6;
}
</style>
